import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, Renderer2, AfterViewInit, ElementRef, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import {Router} from '@angular/router';
import {TemplateGeneratorService} from '@app/services/template-generator.service';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, AbstractControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';

import * as routes from '@app/routes';

import {EMAIL_TEMPLATE_TYPE_ID} from '@app/consts';
import {select, Store} from '@ngrx/store';
import {
  CampaignUpdate,
  CampaignUpdateError,
  CampaignUpdateSuccess,
  getCampaignUpdate,
  getInfluencerError,
  getInfluencers,
  getMailServiceProvider,
  getMailServiceProviderError,
  getMailVerifyError,
  getMailVerifyStatus,
  getTemplate,
  getTemplateSuccess,
  ICampaignState,
  IInfluencersState,
  IMailVerifyState,
  InfluencersListByProject,
  ITemplateState,
  MailServiceProvider,
  MailVerifySenderStatus,
  ResetTemplateState,
  TemplateGet,
  getLoggedInUser,
  IAuthenticationState, IProjectState, getProjects, ResetInfluencerState, ResetMailVerifyState,
  ProjectPlanners, getProjectPlanners
} from '@app/stores';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, lastValueFrom, of, Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {EditorComponent} from '@app/modules/template-generator/editor/editor.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CampaignService} from '@app/services/campaign.service';
import {MailVerifyService} from '@app/services/mail-verify.service';
import {TemplateRevisionsComponent} from '@app/_components/template-revisions/template-revisions.component';
import Swal from 'sweetalert2';
import {VerificationComponent} from '@app/_components/verification/verification.component';
import {MailerDomainService} from '@app/services/mailer-domain.service';

import {TemplateService} from '@app/services/template.service';
import { project } from '@app/routes';
import {NewEditorComponent} from '../new-editor';
import {templateHtml} from '../new-editor/template-html';
import {hasVariableToken} from '@app/_helpers/variable-tokens';
import {startPanelResize} from '@app/_helpers/panel-resize';
import { NewEditorComponent as NewEditorComponent_1 } from '../new-editor/index';
import { CdkDropListGroup } from '@angular/cdk/drag-drop';
import { NgSelectComponent, NgOptionTemplateDirective, NgFooterTemplateDirective, NgLabelTemplateDirective } from '@ng-select/ng-select';
import { VariablesComponent } from '../../../_components/variables/variables.component';
import { SbTextConditionButtonComponent } from '../../../_components/unified/sb-text-condition/sb-text-condition-button.component';
import { RtlEmbeddingButtonComponent } from '../../../_components/rtl-embedding-button/rtl-embedding-button.component';
import { SbTextConditionHintComponent } from '../../../_components/unified/sb-text-condition/sb-text-condition-hint.component';
import { ColorPickerDirective } from '../../shared/directives/colorPicker.directive';
import { SocialSharePreviewComponent } from '../../shared/social-share-preview/social-share-preview.component';
import { AsyncPipe } from '@angular/common';
import { PageShellComponent } from '../../../_components/page-shell/page-shell.component';
import { StatusBarComponent } from '../../status-bar/status-bar.component';
import { NewEditorPreviewComponent } from '../new-editor/preview';
import { EditorComponent as EditorComponent_1 } from '../editor/editor.component';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';

type CampaignEmailForm = FormGroup<{
  email_from_name: FormControl<string | null>;
  email_from: FormControl<string | null>;
  email_reply_to: FormControl<string | null>;
  email_subject: FormControl<string | null>;
  emails_source_message: FormControl<string | null>;
  segment: FormControl<string | null>;
  email_sender_verify_by: FormControl<string | null>;
  email_sender_service_provider_id: FormControl<number | null>;
  email_sender_service_provider_slug: FormControl<string | null>;
  email_disabled: FormControl<string | null>;
}>;

type RecipientForm = FormGroup<{email: FormControl<string | null>}>;

type TestMailForm = FormGroup<{
  timezone: FormControl<any>;
  recipients: FormArray<RecipientForm>;
}>;

@Component({
  selector: 'app-preview',
  templateUrl: './index.html',
  styleUrls: ['./index.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewEditorComponent_1, CdkDropListGroup, ReactiveFormsModule, NgSelectComponent, FormsModule, NgOptionTemplateDirective, NgFooterTemplateDirective, NgLabelTemplateDirective, VariablesComponent, SbTextConditionButtonComponent, RtlEmbeddingButtonComponent, SbTextConditionHintComponent, ColorPickerDirective, SocialSharePreviewComponent, PageShellComponent, StatusBarComponent, NewEditorPreviewComponent, EditorComponent_1, AsyncPipe]
})

export class EmailEditorComponent implements OnInit, OnDestroy, AfterViewInit {
  private router = inject(Router);
  private templateGeneratorService = inject(TemplateGeneratorService);
  private influencerStore = inject<Store<IInfluencersState>>(Store);
  private campaignStore = inject<Store<ICampaignState>>(Store);
  private mailVerifyStore = inject<Store<IMailVerifyState>>(Store);
  private templateStore = inject<Store<ITemplateState>>(Store);
  private formBuilder = inject(FormBuilder);
  private toastr = inject(ToastrService);
  private loaderService = inject(LoaderService);
  private templateService = inject(TemplateService);
  private projectStore = inject<Store<IProjectState>>(Store);
  private _modalService = inject(NgbModal);
  private readonly sbModal = inject(SbModalService);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private campaignService = inject(CampaignService);
  private mailVerifyService = inject(MailVerifyService);
  private mailerDomainService = inject(MailerDomainService);
  private renderer = inject(Renderer2);
  // The page's many plain fields are written from the store, the template generator service,
  // the sender checks, timers and dialogs' promises: each of those marks the view.
  private changeDetector = inject(ChangeDetectorRef);

  readonly editor = viewChild<EditorComponent>('editor');
  readonly newEditorRef = viewChild<NewEditorComponent>('newEditorRef');
  public campaign: any;
  public influencerType;
  public template;
  public influencerCount;
  public template_type_id = EMAIL_TEMPLATE_TYPE_ID;
  public variables = {};
  public variablesFor = '';
  public domainVerificationInfo = false;
  public form: FormGroup;
  public fromEmailVerified = '';
  public replyToEmailVerified = '';
  public fromEmailLocal = '';
  public fromEmailDomain = '';
  public replyToEmailLocal = '';
  public replyToEmailDomain = '';
  public allowedDomains: any[] = [];
  public hasRestrictedDomain = false;
  public toVerifyEmail = false;
  public buttonText = 'Yes, I\'ll share!';
  public buttonColor = '';
  public buttonTextColor = '';
  public linkColor = '#6fa8dc';
  public linkHoverColor = '#4191ff';
  public emailBackgroundColor = '#f0fbff';
  public buttonSpacing = 10;
  public listSpacing = 1;
  public paragraphSpacing = 25;
  public defaultShareLink = '#InfluencerShareLink#';
  public requiredVariables = ['#InfluencerShareLink#', '#InfluencerSocialShareLink#'];
  public templateMeta: any = {};
  public campaignMeta: any = {};
  public sectionsStatus = {email: true, widget: false};
  public newEditor = {
    show: false,
    active: false
  };
  public templateData = {
    body: null,
    bodyJson: null,
    visualEditorId: null,
    campaignId: null,
    influencerTypeId: null,
    templateId: null,
    templateTypeId: null,
  };
  previewWidget = false;
  visible = false;
  submitted = false;
  debounceTimeOut = null;
  isIncludeContent = false;

  public blocks = [];
  public campaignForm: CampaignEmailForm;
  public step;
  unsubscriber = new Subject();
  loader$: Observable<boolean>;
  emailPreviewClicked = false;
  previousEmail: string;
  nextButtonClicked = false;
  isExit = false;
  editorLoaded = false;
  resettingTemplate = false;
  private editorSavePending = false;
  private editorSaved = false;
  readonly sendTestEmail = viewChild<TemplateRef<any>>('sendTestEmail');
  testEmail;
  sampleInfluencerEmail = null;
  testEmailError;
  sampleInfluencerEmailError;
  public mailServiceProviders: any[] = [];
  currentUser: any = {};
  previousFromEmail = '';
  additionalContent = '';
  projects = [];
  planners = [];
  selectedProject: any = null;
  variableLoaded = false;
  landingpageButtonColor: any = '';
  isTestEmailDisable = false;
  sendsEmail = true;
  randomStr = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
  readonly subjectLine = viewChild<ElementRef>('subject');
  private TemplateService: any;
  testMailForm: TestMailForm;
  isNotificationSet$ = new BehaviorSubject(false);
  recipients: FormArray<RecipientForm>;
  formLenght$ = new BehaviorSubject(1);
  formLength: number;
  mode = 'iframe';

  defaultPanelWidth = 700;
  panelWidth = this.defaultPanelWidth;
  panelCollapsed = false;

  constructor() {
    this.onEditorChange = this.onEditorChange.bind(this);
  }

  subscribeStore() {
    this.templateStore.pipe(select(getTemplate))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(data => {
        if (data && this.resettingTemplate) {
          this.resettingTemplate = false;
          const oldTemplateData = Object.assign({}, this.template);
          this.template = null;
          this.changeDetector.markForCheck();
          setTimeout(() => {
            oldTemplateData.body = data.body;
            oldTemplateData.meta = data.meta;
            this.template = oldTemplateData;
            this.templateData = {
              visualEditorId: this.template.visual_editor_id,
              body:  this.template.body,
              bodyJson:  this.template.body_json,
              campaignId: this.template.campaign_id,
              influencerTypeId: this.template.influencer_type_id,
              templateId: this.template.id,
              templateTypeId: this.template.template_type_id
            };
            this.editorSaved = false;
            if (this.template.visual_editor_id) {
              this.newEditor.active = true;
            }
            if (data.meta) {
              this.templateMeta = (typeof data.meta === 'string') ? JSON.parse(data.meta) : data.meta;
            }
            this.buttonText = this.templateMeta?.buttonText || 'I\'m in';
            this.buttonColor = this.templateMeta?.buttonColor || this.landingpageButtonColor;
            this.buttonTextColor = this.templateMeta?.buttonTextColor || '#ffffff';;
            this.linkColor = this.templateMeta?.linkColor || '#6fa8dc';
            this.linkHoverColor = this.templateMeta?.linkHoverColor || '#4191ff';
            this.emailBackgroundColor = this.templateMeta?.emailBackgroundColor || '#f0fbff';
            this.buttonSpacing = this.templateMeta?.buttonSpacing || '';
            this.listSpacing = this.templateMeta?.listSpacing || 1;
            this.paragraphSpacing = this.templateMeta?.paragraphSpacing || '';
            this.replaceToProjectLogo();
            this.changeDetector.markForCheck();
          }, 200);
        }
      });
    this.templateStore.pipe(select(getTemplateSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        if (success) {
          if (this.emailPreviewClicked) {
            this.emailPreviewClicked = false;
            this.toastr.success(success, 'Success');
          }
        }
      });
    this.campaignStore.pipe(select(getCampaignUpdate))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaign => {
        if (campaign) {
          if (this.previewWidget) {
            this.previewWidget = false;
            this.templateGeneratorService.widgetPreview(campaign.id);
          }
          if (this.nextButtonClicked) {
            if (this.isExit) {
              this.router.navigateByUrl('/' + routes.campaigns({projectId: this.campaign.project_id}));
            } else {
              this.router.navigateByUrl(
                routes.launchCampaign({
                  projectId: this.campaign.project_id,
                  campaignId: this.campaign.id
                })
              );
            }
          }
        }
      });
    // onCampaignUpdated replays the last saved template, which may be another campaign's.
    this.templateGeneratorService.onCampaignUpdated
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(template => {
        if (template && this.editorSavePending) {
          this.editorSavePending = false;
          this.editorSaved = true;
          this.toastr.success('Email template saved', 'Success');
        }
      });
    this.projectStore.pipe(select(getProjects))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(projects => {
        if (projects) {
          this.projects = projects;
          this.replaceToProjectLogo();
          this.changeDetector.markForCheck();
        }
      });
    this.projectStore.pipe(select(getProjectPlanners))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(projectPlanners => {
        if (projectPlanners) {
          this.planners = projectPlanners;
          this.populatePlannersEmail();
          // Also refreshes the open test email dialog, whose recipients this fills.
          this.changeDetector.markForCheck();
        }
      });
    this.influencerStoreSubscribe();
    this.mailVerifyStoreSubscribe();
  }

  replaceToProjectLogo() {
    if (!this.campaign?.project_id) {
      return null;
    }
    if (!this.projects || !this.projects.length) {
      return null;
    }
    if (!this.selectedProject) {
      this.selectedProject = this.projects.find(x => Number(x.id) === Number(this.campaign?.project_id));
      if (!this.selectedProject) {
        return null;
      }
    }
    if (!this.selectedProject.image) {
      return null;
    }
    const imgElement = document.querySelector('[data-src-variable="#ProjectImage#"]');
    if (!imgElement) {
      return null;
    }
    imgElement.setAttribute('src', this.selectedProject.image);
  }

  influencerStoreSubscribe() {
    this.influencerStore.pipe(select(getInfluencerError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.influencerStore.pipe(select(getInfluencers))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencers => {
        if (influencers && influencers.length > 0) {
          this.filterInfluencers(influencers);
        }
      });
  }

  mailVerifyStoreSubscribe() {
    this.influencerStore.pipe(select(getMailServiceProviderError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.influencerStore.pipe(select(getMailServiceProvider))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(data => {
        if (data && data.length > 0) {
          this.mailServiceProviders = Object.assign([], data);
          if (!this.currentUser?.can?.('view-advanced-editor', 'template')) {
            this.mailServiceProviders = this.mailServiceProviders
              .filter(p => p.slug !== 'mailchimp')
              .map(p => p.slug === 'aws_ses' ? { ...p, name: 'Send Emails' } : p);
          }
          this.changeDetector.markForCheck();
        }
      });
  }

  filterInfluencers(influencers) {
    if (this.campaign) {
      // A campaign without a segment sends to no one.
      const segment = this.campaign.segments?.[0];
      const filteredInfluencers = segment
        ? influencers.filter(influencer => Number(influencer.project_influencer_segment_id) === Number(segment.id))
        : [];
      this.influencerCount = filteredInfluencers.length;
      // From the store, or the retry's timeout.
      this.changeDetector.markForCheck();
    } else {
      setTimeout(() => {
        this.filterInfluencers(influencers);
      }, 1000);
      return;
    }
  }

  ngOnInit() {
    this.initTestForm();
    this.templateGeneratorService.forceReloadCampaign();
    this.templateGeneratorService.subscribeStore();
    this.loader$ = this.loaderService.loader$;
    this.subscribeStore();
    this.initializeCampaignForm();
    this.subscribeToCampaign();
    this.mailVerifyStore.dispatch(ResetMailVerifyState({params: {error: '', serviceProviders: null}}));
    // if (this.currentUser && this.currentUser.user_type === '1') {
    this.mailVerifyStore.dispatch(MailServiceProvider({params: {}}));
    this.authenticationStore.pipe(select(getLoggedInUser)).subscribe(user => {
      if (user) {
        this.currentUser = user;
        this.changeDetector.markForCheck();
      }
    }
    );
    // }

    /*
    const node = document.createElement('link');
    node.href = environment.apiUrl + '/public/assets/templates/v1/email.css';
    node.type = 'text/css';
    node.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(node);
    */
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const subjectLine = this.subjectLine();
      if (!subjectLine?.nativeElement) {
        return;
      }
      subjectLine.nativeElement.style.height = '5px';
      const scrollHeight = (subjectLine.nativeElement.scrollHeight) + 15;
      this.renderer.setStyle(subjectLine.nativeElement, 'height', `${scrollHeight}px`);
    }, 500);
  }

  applyRTLEmbedding() {
    const cursorPosition = this.subjectLine().nativeElement.selectionStart;
    const inputText = this.campaignForm.value.email_subject;
    const convertedText = inputText.slice(0, cursorPosition) + '\u202B' + inputText.slice(cursorPosition);
    this.campaignForm.patchValue({ email_subject: convertedText });
    this.subjectLine().nativeElement.value = convertedText;
  }

  setStatusBar() {
    this.step = {
      title: 'Email',
      params: {
        projectId: this.campaign.project_id,
        campaignId: this.campaign.id,
        campaignName: this.campaign.name
      }
    };
  }

  customizeFromAddress() {
    const from_address = this.campaignForm.get('email_from').value;
    if (from_address) {
      return;
    }
    this.campaignMeta.email_customized = !this.campaignMeta.email_customized;
    if (!this.campaignMeta.email_customized) {
      this.f.email_from.setValidators([Validators.required, Validators.email]);
      this.campaignForm.patchValue({email_from: ''});
    } else {
      this.f.email_from.setValidators([Validators.email, Validators.required]);
    }
    this.f.email_from.updateValueAndValidity();
  }

  onAddVariablesButtonClick(variablesFor) {
    this.variablesFor = variablesFor;
  }

  onVariableClick(variable, element = null) {

    const value = this.campaignForm.value[this.variablesFor];

    const varValue = variable.key;

    if (element && element.selectionStart || element.selectionStart === '0' || element.selectionStart === 0) {
      const startPos = element.selectionStart;
      const endPos = element.selectionEnd;
      if (element.selectionStart === '0' || element.selectionStart === 0) {
        this.campaignForm.patchValue({[this.variablesFor]: `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`});
      } else {
        this.campaignForm.patchValue({[this.variablesFor]: `${value.substring(0, startPos)}${varValue}${value.substring(endPos, value.length)}`});
      }
    } else {
      this.campaignForm.patchValue({[this.variablesFor]: `${value}${varValue}`});
    }
    this.variablesFor = '';
  }

  onButtonVariableClick(variable, textFor) {
    if (textFor === 'buttonText') {
      this.buttonText = `${this.buttonText} ${variable.key}`;
    }
  }

  updateValue(variable, textFor) {
    const value = this.campaignMeta[textFor] || '';
    const varValue = variable.key;
    this.campaignMeta[textFor] = `${value} ${varValue}`;
  }

  selectMailProvider(ev) {
    this.campaignForm.patchValue({email_sender_service_provider_slug: ev.value});
    const email_sender_service_provider = this.mailServiceProviders.find(item => item.slug === ev.value);
    if (email_sender_service_provider) {
      this.campaignForm.patchValue({email_sender_service_provider_id: email_sender_service_provider.id});
      this.save();
    }
    this.validateMailAddress();
  }

  onSendsEmailChange() {
    if (!this.sendsEmail) {
      this.isTestEmailDisable = true;
      this.campaignForm.controls['email_from_name'].disable();
      this.campaignForm.controls['email_from'].disable();
      this.campaignForm.controls['email_reply_to'].disable();
      this.campaignForm.controls['email_subject'].disable();
      this.campaignForm.controls['emails_source_message'].disable();
      this.campaignForm.patchValue({ email_disabled: 'true' });
      this.save();
    } else {
      this.isTestEmailDisable = false;
      this.campaignForm.controls['email_from_name'].enable();
      this.campaignForm.controls['email_from'].enable();
      this.campaignForm.controls['email_reply_to'].enable();
      this.campaignForm.controls['email_subject'].enable();
      this.campaignForm.controls['emails_source_message'].enable();
      this.campaignForm.patchValue({ email_disabled: 'false' });
      this.save();
      this.loadAllowedDomains();
      this.validateMailAddress();
    }
  }

  subscribeToCampaign() {
    this.templateGeneratorService.onCampaignLoaded
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(async campaign => {
        if (!campaign) {
          return;
        }
        campaign = Object.assign({}, campaign);
        this.campaign = campaign;
        this.replaceToProjectLogo();
        this.templateStoreSubscribe();
        this.previousEmail = this.campaign.email_from;
        if (campaign.meta) {
          this.campaignMeta = (typeof campaign.meta === 'string') ? {...JSON.parse(campaign.meta)} : {...campaign.meta};
        }
        if (!this.campaignMeta.hasOwnProperty('widget_active')) {
          this.campaignMeta.widget_active = true;
        }
        if (!this.campaignMeta.hasOwnProperty('share_link_customized')) {
          this.campaignMeta.share_link_customized = false;
        }
        if (!this.campaignMeta.hasOwnProperty('share_link')) {
          this.campaignMeta.share_link = this.defaultShareLink;
        }
        if (!this.campaignMeta.hasOwnProperty('email_customized')) {
          this.campaignMeta.email_customized = false;
        }
        if (!campaign.email_sender_verify_by) {
          campaign.email_sender_verify_by = 'domain';
        }
        // A campaign without a segment has no influencer type; its variables load without one.
        const influencerTypeId = this.campaign.segments?.[0]?.influencer_type_id;
        this.templateGeneratorService.loadVariables({
          ...(influencerTypeId ? {influencerTypeId} : {}),
          campaignId: this.campaign.id
        }, (vars) => {
          if (vars && Object.keys(vars).length) {
            this.variableLoaded = true;
          }
          const result = [];
          Object.entries(vars).forEach(([key, value]) => {
            if (value.hasOwnProperty('group') && value['group']) {
              if (!result[value['group']]) {
                result[value['group']] = [];
              }
              result[value['group']].push({
                name: value['title'].replace(value['group'].toString().toLowerCase().trim(), ''),
                key: value['alias'] ? `#${value['alias']}#` : value['key'],
                valueType: value['valueType']
              });
            } else {
              if (!result['generic']) {
                result['generic'] = [];
              }
              result['generic'].push({
                name: value['title'],
                key: value['key'],
                valueType: value['valueType']
              });
            }
          });
          this.variables = result;
          this.changeDetector.markForCheck();
        });

        this.setStatusBar();
        this.applyCampaign(campaign, this.campaign.segments || []);

        this.influencerStore.dispatch(InfluencersListByProject({
          projectId: this.campaign.project_id,
          campaignId: this.campaign.id
        }));

        this.influencerType = this.campaign.segments?.[0]?.influencer_type;

        this.templateGeneratorService.loadClientTemplate({
          templateTypeId: this.template_type_id,
          sourceTemplateId: 2
        }, {createIfNotExist: true, forceTouch: false});
        this.templateGeneratorService.onTemplateChanged[this.template_type_id]
          .pipe(takeUntil(this.unsubscriber))
          .subscribe((template) => {
            if (template && !this.resettingTemplate) {
              this.template = Object.assign({}, template);
              // The open editor owns templateData: a background refresh replacing it reloads the
              // editor, and a legacy template arrives without the document the editor read built.
              if (!this.newEditor.show) {
                const sameTemplate = Number(this.templateData?.templateId) === Number(this.template.id);
                this.templateData = {
                  visualEditorId: this.template.visual_editor_id,
                  body: this.template.body,
                  bodyJson: this.template.body_json ?? (sameTemplate ? this.templateData.bodyJson : null),
                  campaignId: this.template.campaign_id,
                  influencerTypeId: this.template.influencer_type_id,
                  templateId: this.template.id,
                  templateTypeId: this.template.template_type_id
                };
              }
              if (template.visual_editor_id) {
                this.newEditor.active = true;
              }
              this.editorLoaded = true;

              if (template.meta) {
                this.templateMeta = (typeof template.meta === 'string') ? JSON.parse(template.meta) : template.meta;
                this.buttonText = this.templateMeta.buttonText || 'I\'m in';
                this.buttonColor = this.templateMeta.buttonColor || this.landingpageButtonColor || '#333399';
                this.buttonTextColor = this.templateMeta?.buttonTextColor || '#ffffff';
                this.linkColor = this.templateMeta.linkColor || '#6fa8dc';
                this.linkHoverColor = this.templateMeta.linkHoverColor || '#4191ff';
                this.emailBackgroundColor = this.templateMeta.emailBackgroundColor || '#f0fbff';
                this.buttonSpacing = this.templateMeta.buttonSpacing || '';
                this.listSpacing = this.templateMeta.listSpacing || 1;
                this.paragraphSpacing = this.templateMeta.paragraphSpacing || '';
              }
              this.replaceToProjectLogo();
              this.changeDetector.markForCheck();
            }
          });
        this.changeDetector.markForCheck();
        if (this.campaign.email_from) {
          // this.mailVerifyStore.dispatch(MailVerifySenderStatus({params: {identity: this.campaign.email_from}}));
          this.validateMailAddress();
        }
      });

  }

  templateStoreSubscribe() {
    if (this.campaign.id) {
      const params = {
        campaign_id: this.campaign.id,
        template_type_id: 1
      };
      this.templateService.getAll(params).subscribe(response => {
        if (response['data'].length > 0) {
          this.landingpageButtonColor = response['data'][0].properties.button_color || '#333399' ;
        } else {
          this.landingpageButtonColor = '#333399';
        }
      });
    } else {
      this.landingpageButtonColor = '#333399';
    }
  }

  async validateMailAddress(fromForm: boolean = false, resend = false) {
    //
    // Validate form
    if (this.campaignForm.get('email_from')?.errors?.email === true) {
      return;
    }

    //
    // Apply validation to other fields
    this.customizeFromAddress();

    //
    // Force email customized
    // this.campaignMeta.email_customized = true;
    this.campaignMeta.email_customized = !!this.campaignForm.get('email_from').value;

    //
    // Get email_form and process
    const from_address = this.campaignForm.get('email_from').value;
    // validate
    if (fromForm === true && from_address && from_address !== this.previousEmail && !this.f.email_from.errors) {
      this.previousEmail = from_address;
      // this.campaignForm.patchValue({email_sender_verify_by: null});
    }

    if (from_address) {
      this.toVerifyEmail = true;
      // this.mailVerifyStore.dispatch(MailVerifySenderStatus({params: {identity: from_address}}));
      this.callValidationOnServer(from_address, fromForm, resend);
    }
  }

  callValidationOnServer(identity: string, fromFrom: boolean = false, resend = false) {
    if (this.debounceTimeOut) {
      clearTimeout(this.debounceTimeOut);
    }
    this.debounceTimeOut = setTimeout(async () => {
      await this.validateMailAddressOnServer(identity, fromFrom, resend, this.previousFromEmail !== identity);
      if (this.previousFromEmail !== identity) {
        this.previousFromEmail = identity;
      }
    }, 1000);
  }

  async validateMailAddressOnServer(identity: string, fromFrom: boolean = false, resend = false, resetVerifyBy = false) {
    this.loaderService.show();

    const domain = identity.includes('@') ? identity.split('@')[1] : identity;
    const service_provider = this.campaignForm.value.email_sender_service_provider_slug;

    try {
      const response: any = await lastValueFrom(this.mailVerifyService.verifySenderStatus({
        identity: domain,
        userId: this.currentUser.id,
        campaignCode: this.campaign.code,
        ...(service_provider ? {service_provider} : {}),
        ...(resend ? {resend} : {})
      }));

      if (response?.success !== true) {
        throw new Error('Failed to validate domain, try again');
      }
      const data = response.data;

      if (data.showConfigPopup && data?.identity?.verification_status === 'unverified') {
        this.showVerificationStatus();
      }

      const status: 'verified' | 'unverified' = data?.identity?.verification_status === 'verified' ? 'verified' : 'unverified';
      this.applyDomainStatus(domain, status);
    } catch (error) {
      this.toastr.error(this.loaderService.getErrorMessage(error), 'Error');
    }

    this.loaderService.hide();
    this.changeDetector.markForCheck();
  }

  private applyDomainStatus(domain: string, status: 'verified' | 'unverified') {
    if (this.fromEmailDomain === domain) {
      this.fromEmailVerified = status;
    }
    if (this.replyToEmailDomain === domain) {
      this.replyToEmailVerified = status;
    }
  }

  loadAllowedDomains() {
    if (!this.campaign?.project_id) {
      return;
    }
    this.mailerDomainService.getAllowedForProject(this.campaign.project_id)
      .subscribe((resp: any) => {
        if (resp.success && Array.isArray(resp.data)) {
          this.allowedDomains = resp.data;
          this.updateDomainVerificationStatus();
          this.changeDetector.markForCheck();
        }
      });
  }

  private findAllowedDomain(domain: string | undefined | null) {
    if (!domain || !this.allowedDomains?.length) {
      return null;
    }
    const normalized = String(domain).trim().toLowerCase();
    return this.allowedDomains.find(
      (d) => String(d.identity || '').trim().toLowerCase() === normalized
    ) || null;
  }

  updateDomainVerificationStatus() {
    const restrictedDomains = ['snoball.events', 'snoball.it'];
    const enforceAllowList = Array.isArray(this.allowedDomains) && this.allowedDomains.length > 0;
    this.hasRestrictedDomain = false;
    if (this.fromEmailDomain) {
      const match = this.findAllowedDomain(this.fromEmailDomain);
      if (!match) {
        if (restrictedDomains.includes(this.fromEmailDomain.toLowerCase())) {
          this.hasRestrictedDomain = true;
          this.fromEmailLocal = '';
          this.fromEmailDomain = '';
          this.fromEmailVerified = '';
          this.syncFromEmail();
        } else if (enforceAllowList) {
          this.fromEmailLocal = '';
          this.fromEmailDomain = '';
          this.fromEmailVerified = '';
          this.syncFromEmail();
        }
      } else {
        this.fromEmailVerified = match.verification_status || 'unverified';
      }
    }
    if (this.replyToEmailDomain) {
      const match = this.findAllowedDomain(this.replyToEmailDomain);
      if (!match) {
        if (restrictedDomains.includes(this.replyToEmailDomain.toLowerCase())) {
          this.hasRestrictedDomain = true;
          this.replyToEmailLocal = '';
          this.replyToEmailDomain = '';
          this.replyToEmailVerified = '';
          this.syncReplyToEmail();
        } else if (enforceAllowList) {
          this.replyToEmailLocal = '';
          this.replyToEmailDomain = '';
          this.replyToEmailVerified = '';
          this.syncReplyToEmail();
        }
      } else {
        this.replyToEmailVerified = match.verification_status || 'unverified';
      }
    }
  }

  private stripRestrictedSenderDomainsFromSplitFieldsIfNeeded(): void {
    if (this.currentUser?.can('use-restricted-email-domains', 'campaign')) {
      return;
    }
    const restrictedDomains = ['snoball.events', 'snoball.it'];
    let touched = false;
    const fromDomain = this.fromEmailDomain?.toLowerCase();
    if (fromDomain && restrictedDomains.includes(fromDomain)) {
      this.fromEmailLocal = '';
      this.fromEmailDomain = '';
      this.fromEmailVerified = '';
      touched = true;
    }
    const replyDomain = this.replyToEmailDomain?.toLowerCase();
    if (replyDomain && restrictedDomains.includes(replyDomain)) {
      const safeFrom = this.fromEmailDomain?.toLowerCase();
      if (safeFrom && !restrictedDomains.includes(safeFrom)) {
        this.replyToEmailLocal = this.fromEmailLocal;
        this.replyToEmailDomain = this.fromEmailDomain;
        const match = this.findAllowedDomain(this.replyToEmailDomain);
        this.replyToEmailVerified = match?.verification_status === 'verified' ? 'verified' : 'unverified';
      } else {
        this.replyToEmailLocal = '';
        this.replyToEmailDomain = '';
        this.replyToEmailVerified = '';
      }
      touched = true;
    }
    if (touched) {
      this.hasRestrictedDomain = false;
      this.syncFromEmail();
      this.syncReplyToEmail();
    }
  }

  splitEmail(email: string): { local: string; domain: string } {
    if (!email || !email.includes('@')) {
      return { local: email || '', domain: '' };
    }
    const idx = email.indexOf('@');
    return { local: email.substring(0, idx), domain: email.substring(idx + 1) };
  }

  onFromEmailLocalChange(value: string) {
    this.fromEmailLocal = value;
    this.syncFromEmail();
  }

  onFromDomainChange(domain: any) {
    if (!domain) {
      this.fromEmailDomain = '';
      this.fromEmailVerified = 'unverified';
    } else {
      this.fromEmailDomain = typeof domain === 'string' ? domain : domain.identity;
      this.hasRestrictedDomain = false;
    }
    this.syncFromEmail();
    this.replyToEmailDomain = this.fromEmailDomain;
    this.syncReplyToEmail();
    if (this.fromEmailDomain) {
      const match = this.findAllowedDomain(this.fromEmailDomain);
      const status: 'verified' | 'unverified' = match?.verification_status === 'verified' ? 'verified' : 'unverified';
      this.fromEmailVerified = status;
      this.replyToEmailVerified = status;
      this.validateMailAddressOnServer(this.fromEmailDomain);
    } else {
      this.replyToEmailVerified = 'unverified';
    }
  }

  onReplyToEmailLocalChange(value: string) {
    this.replyToEmailLocal = value;
    this.syncReplyToEmail();
  }

  onReplyToDomainChange(domain: any) {
    if (!domain) {
      this.replyToEmailDomain = '';
      this.replyToEmailVerified = 'unverified';
    } else {
      this.replyToEmailDomain = typeof domain === 'string' ? domain : domain.identity;
      this.hasRestrictedDomain = false;
    }
    this.syncReplyToEmail();
    this.fromEmailDomain = this.replyToEmailDomain;
    this.syncFromEmail();
    if (this.replyToEmailDomain) {
      const match = this.findAllowedDomain(this.replyToEmailDomain);
      const status: 'verified' | 'unverified' = match?.verification_status === 'verified' ? 'verified' : 'unverified';
      this.replyToEmailVerified = status;
      this.fromEmailVerified = status;
      this.validateReplyToDomainOnServer(this.replyToEmailDomain);
    } else {
      this.fromEmailVerified = 'unverified';
    }
  }

  syncFromEmail() {
    const email = this.fromEmailLocal && this.fromEmailDomain
      ? `${this.fromEmailLocal}@${this.fromEmailDomain}` : this.fromEmailLocal || '';
    this.campaignForm.patchValue({ email_from: email }, { emitEvent: false });
    this.campaignForm.get('email_from').updateValueAndValidity();
  }

  syncReplyToEmail() {
    const email = this.replyToEmailLocal && this.replyToEmailDomain
      ? `${this.replyToEmailLocal}@${this.replyToEmailDomain}` : this.replyToEmailLocal || '';
    this.campaignForm.patchValue({ email_reply_to: email }, { emitEvent: false });
    this.campaignForm.get('email_reply_to').updateValueAndValidity();
  }

  openFromDomainDropdown(select: any) {
    if (select) {
      select.open();
    }
  }

  openReplyToDomainDropdown(select: any) {
    if (select) {
      select.open();
    }
  }

  async validateReplyToDomainOnServer(domain: string) {
    const service_provider = this.campaignForm.value.email_sender_service_provider_slug;
    try {
      const response: any = await lastValueFrom(this.mailVerifyService.verifySenderStatus({
        identity: domain,
        userId: this.currentUser.id,
        campaignCode: this.campaign.code,
        ...(service_provider ? { service_provider } : {}),
      }));
      if (response?.success === true) {
        const status: 'verified' | 'unverified' = response.data?.identity?.verification_status === 'verified' ? 'verified' : 'unverified';
        this.applyDomainStatus(domain, status);
      }
    } catch (error) {
      // silently fail for reply-to validation
    }
    this.changeDetector.markForCheck();
  }

  showReplyToVerificationStatus() {
    const domain = this.replyToEmailDomain;
    if (!domain) {
      return;
    }
    const status = (this.replyToEmailVerified === 'verified' ? 'verified' : 'unverified') as 'verified' | 'unverified';
    this.openVerificationModalForIdentity(domain, status);
  }

  get canAddMailerDomain(): boolean {
    return !!(
      this.currentUser?.can('view-admin-features', 'navigation')
      || this.currentUser?.can('view-domains-menu', 'navigation')
    );
  }

  openDomainVerificationFromDropdown(
    event: MouseEvent,
    item: { identity?: string; verification_status?: string },
    select?: { close?: () => void }
  ) {
    event.stopPropagation();
    event.preventDefault();
    if (select && typeof select.close === 'function') {
      select.close();
    }
    const domain = item?.identity;
    if (!domain) {
      return;
    }
    const status = item?.verification_status === 'verified' ? 'verified' : 'unverified';
    this.openVerificationModalForIdentity(domain, status);
  }

  navigateToAddMailerDomain(event: MouseEvent, select?: { close?: () => void }) {
    event.stopPropagation();
    event.preventDefault();
    if (select && typeof select.close === 'function') {
      select.close();
    }
    this.router.navigate(['/domains'], { queryParams: { add: '1' } });
  }

  private openVerificationModalForIdentity(domain: string, verificationStatus: 'verified' | 'unverified') {
    if (!domain) {
      return;
    }

    this.syncFromEmail();
    this.syncReplyToEmail();
    this.stripRestrictedSenderDomainsFromSplitFieldsIfNeeded();

    if (!this.campaignForm.value.email_sender_verify_by) {
      this.campaignForm.patchValue({ email_sender_verify_by: 'domain' });
      this.save();
    }

    const modelRef = this.sbModal.openComponent(VerificationComponent, { centered: true, keyboard: true, size: 'lg' }, {
      fromEmailVerified: verificationStatus,
      emailSenderVerifyBy: 'domain',
      fromEmail: domain,
      emailSenderServiceProviderSlug: this.campaignForm.value.email_sender_service_provider_slug,
      mailServiceProviders: this.mailServiceProviders,
      currentUser: this.currentUser,
      mode: this.mode,
    });
    modelRef.result.then((result) => {
      if (!result) {
        return;
      }
      let serviceProviderSlug: string | undefined;
      let verificationFailedInModal = false;
      if (typeof result === 'string') {
        serviceProviderSlug = result;
      } else if (typeof result === 'object') {
        serviceProviderSlug = result.emailSenderServiceProviderSlug;
        verificationFailedInModal = !!result.verificationRequestFailed;
      }
      if (serviceProviderSlug) {
        this.campaignForm.patchValue({ email_sender_service_provider_slug: serviceProviderSlug });
        const esp = this.mailServiceProviders.find(item => item.slug === serviceProviderSlug);
        if (esp) {
          this.campaignForm.patchValue({ email_sender_service_provider_id: esp.id });
          this.syncFromEmail();
          this.syncReplyToEmail();
          this.stripRestrictedSenderDomainsFromSplitFieldsIfNeeded();
          this.save();
        }
      }
      if (!verificationFailedInModal) {
        this.validateMailAddressOnServer(domain);
        if (this.replyToEmailDomain === domain) {
          this.validateReplyToDomainOnServer(domain);
        }
      }
      this.loadAllowedDomains();
      this.changeDetector.markForCheck();
    }, () => {});
  }

  customizeLink() {
    if (!this.campaignMeta['share_link_customized']) {
      this.campaignMeta['share_link'] = this.defaultShareLink;
    }
  }

  onEditorChange({body, body_json, styles, visual_editor_id}) {
    return this.templateGeneratorService.saveClientTemplate({
      id: this.template.id,
      templateTypeId: this.template_type_id,
      campaignId: this.campaign.id,
      visualEditorId: visual_editor_id,
      clientTemplate: {
        body,
        body_json,
        style: styles,
        meta: {
          ...(this.templateMeta ? this.templateMeta : {}),
          buttonText: this.buttonText,
          buttonColor: this.buttonColor,
          buttonTextColor: this.buttonTextColor,
          linkColor: this.linkColor,
          linkHoverColor: this.linkHoverColor,
          emailBackgroundColor: this.emailBackgroundColor,
          buttonSpacing: this.buttonSpacing || '',
          listSpacing: this.listSpacing || 1,
          paragraphSpacing: this.paragraphSpacing || ''
        }
      }
    });
  }

  async getProjectPlanners() {
    this.projectStore.dispatch(ProjectPlanners({projectId: this.campaign.project_id}));
  }

  populatePlannersEmail() {
    if (this.planners.length) {
      let emailIds = this.planners.map(planner => planner.email);
      emailIds = emailIds.filter((email: any) => email !== this.currentUser.email);
      if (emailIds && emailIds.length) {
        for (const emailId of emailIds) {
          this.recipients = this.testMailForm.controls.recipients;
          this.recipients.push(this.createRecipient(false, emailId));
        }
      }
    }
  }

  async onSendTestEmailButtonClick() {
    await this.save('onSendTestEmailButtonClick');
    const modelRef = this._modalService.open(this.sendTestEmail(), {
      centered: true,
      size: 'md',
      keyboard: true,
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
    this.getProjectPlanners();
    this.initTestForm();
    this.changeDetector.markForCheck();
  }

  async sendTestEmails(modal: any) {
    try {
      await this.sendTestEmailsFromDialog(modal);
    } finally {
      // Called from the test email dialog, whose events do not mark this view.
      this.changeDetector.markForCheck();
    }
  }

  private async sendTestEmailsFromDialog(modal: any) {
    this.submitted = true;
    if (this.testMailForm.get('recipients').invalid) {
      this.toastr.error('Please enter valid email address', 'Error');
      return;
    }
    const recipients = this.testMailForm.get('recipients').value.map((val) => {
      if (val.email) {
        return val.email;
      } else {
        return;
      }
    });

    if (recipients.length < 1) {
      this.toastr.error('Please add recipients', 'Error');
      return;
    }
    if (!this.campaignForm.value.email_sender_verify_by) {
      this.campaignForm.patchValue({email_sender_verify_by: 'domain'});
    }
    if (this.campaignForm.invalid) {
      modal.close();
      this.toastr.error('Please fill in all required email fields', 'Error');
      return;
    }
    if (recipients) {
      if (this.sampleInfluencerEmail) {
        if (!this.validateEmail(this.sampleInfluencerEmail)) {
          this.toastr.error('Please enter valid email address', 'Error');
          return;
        }
      }
      if (this.campaignForm.get('email_from').value && this.fromEmailVerified && this.fromEmailVerified === 'unverified') {
        modal.close();
        this.toastr.warning('Please verify your email', 'Warning');
        return;
      }
      await this.save('sendTestEmails');
      modal.close();
      this.emailPreviewClicked = true;
      if (this.additionalContent) {
        this.additionalContent = `<div class="col-lg-7" style="background: white;
                                    border: 3px solid #4bb7e3;">
                                    <div style="width: 70%;
                                    margin: 0 auto;
                                    padding: 16px 10px;
                                    font-family: 'omnesregular',Helvetica;
                                    color: #202020 !important;
                                    font-size: 14px;">` + this.additionalContent + `</div></div>`;
      }
      this.templateGeneratorService.sendTestEmail(recipients, this.sampleInfluencerEmail, this.additionalContent);
      this.testMailForm.reset();
      this.sampleInfluencerEmail = '';
      this.isIncludeContent = false;
      this.additionalContent = '';

    } else {
      this.toastr.error('Please add recipients', 'Error');
      return;
    }
  }

  validateEmail(email) {
    const tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
    const emailParts = email.split('@');

    if (emailParts.length !== 2) {
      return false;
    }

    const account = emailParts[0];
    const address = emailParts[1];

    if (account.length > 64) {
      return false;
    } else if (address.length > 255) {
      return false;
    }

    const domainParts = address.split('.');
    if (domainParts.some(function(part) {
      return part.length > 63;
    })) {
      return false;
    }

    return tester.test(email);
  }

  async save(requesterName = null) {
    const editor = this.editor();
    if (!!this.templateData.visualEditorId) {
      const template = {
        visual_editor_id: this.templateData.visualEditorId,
        body: this.templateData.body,
        body_json: this.templateData.bodyJson,
        styles: null,
        campaign_id: this.templateData.campaignId,
        influencer_type_id: this.templateData.influencerTypeId,
        template_id: this.templateData.templateId,
        template_type_id: this.templateData.templateTypeId
      };
      // The editor's Save already saved this document.
      if (requesterName !== 'onSendTestEmailButtonClick' && requesterName !== 'sendTestEmails' && !this.editorSaved) {
        this.onEditorChange(template);
      }
    } else if (editor) {
      const template: any = editor.buildUpdatedTemplate();
      this.onEditorChange({ ...template, body_json: null});
    }

    let campaign: any = this.campaignForm.value;
    delete campaign.segment;
    campaign = {
      ...campaign,
      meta: {
        ...campaign.meta,
        ...this.campaignMeta
      }
    };
    // this.campaignStore.dispatch(CampaignUpdate({campaign, campaignId: this.campaign.id}));
    this.loaderService.show();
    return await lastValueFrom(this.campaignService.updateCampaign(campaign, this.campaign.id).pipe(
      map((resp: any) => {
        if (resp.success) {
          this.loaderService.hide();
          return this.campaignStore.dispatch(CampaignUpdateSuccess({campaign: resp.data}));
        }
        this.loaderService.hide(true);
        return this.campaignStore.dispatch(CampaignUpdateError({error: this.loaderService.getErrorMessage(resp)}));
      }),
      catchError(error => {
        this.loaderService.hide(true);
        return of(this.campaignStore.dispatch(CampaignUpdateError({error: this.loaderService.getErrorMessage(error)})));
      })
    ));
  }

  async shareWidgetPreview() {
    this.submitted = true;
    if (this.campaignForm.invalid) {
      return;
    }
    this.previewWidget = true;
    await this.save();
  }

  async onNextButtonClick(exit = false) {
    if (!this.campaignForm.value.email_sender_verify_by) {
      this.campaignForm.patchValue({email_sender_verify_by: 'domain'});
    }
    this.submitted = true;
    if (this.campaignForm.invalid) {
      return;
    }
    this.nextButtonClicked = true;
    this.isExit = exit;
    await this.saveEmailTemplate();
  }

  async saveEmailTemplate() {
    // const template: any = this.editor.buildUpdatedTemplate();
    // Check what save() stores: a new-editor edit lives in templateData until it is saved.
    const html = this.templateData.visualEditorId
      ? templateHtml(this.templateData.body, this.templateData.bodyJson)
      : templateHtml(this.template?.body, this.template?.body_json);
    if (!this.requiredVariables.some((key) => hasVariableToken(html, key))) {
      Swal.fire({
        // title: '#InfluencerRegistrationUrl# is not used on the page. This would cause problem with report as well as referral tracking system. Are you sure you want to continue?',
        title: `${this.requiredVariables.join(' or ')} is not used on the page. This would cause problems with reports and the referral tracking system. Are you sure you want to continue?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Close',
        width: '70%'
      }).then(async result => {
        if (result.value) {
          await this.save();
        } else {
          return null;
        }
      });
    } else {
      await this.save();
    }
  }

  get f() {
    return this.campaignForm.controls;
  }

  onSaveButtonClick() {
    this.onNextButtonClick(true);
  }

  onBackButtonClick() {
    this.router.navigateByUrl(
      routes.campaignShare({
        projectId: this.campaign.project_id,
        campaignId: this.campaign.id
      })
    );
  }

  showTemplateRevisions() {
    const modelRef = this.sbModal.openComponent(TemplateRevisionsComponent, {centered: true, keyboard: true, size: 'xl'}, {
      templateId: this.template.id,
      canReset: false,
    });
    modelRef.result.then((result) => {
      if (result.data) {
        result.data = Object.assign({}, result.data);
        if (result.data.meta) {
          result.data.meta = (typeof result.data.meta === 'string') ? JSON.parse(result.data.meta) : result.data.meta;
          this.templateMeta = result.data.meta;
          this.template = null;
          this.changeDetector.markForCheck();
          setTimeout(() => {
            this.template = result.data;
            this.templateData = {
              visualEditorId: this.template.visualEditorId,
              body:  this.template.body,
              bodyJson:  this.template.body_json,
              campaignId: this.template.campaign_id,
              influencerTypeId: this.template.influencer_type_id,
              templateId: this.template.id,
              templateTypeId: this.template.template_type_id
            };
            this.editorSaved = false;

            if (this.template.visual_editor_id) {
              this.newEditor.active = true;
            }

            this.buttonText = this.templateMeta.buttonText || 'I\'m in';
            this.buttonColor = this.templateMeta.buttonColor || '#333399';
            this.buttonTextColor = this.templateMeta?.buttonTextColor || '#ffffff';;
            this.linkColor = this.templateMeta.linkColor || '#3b3e66';
            this.linkHoverColor = this.templateMeta.linkHoverColor || '#4191ff';
            this.emailBackgroundColor = this.templateMeta.emailBackgroundColor || '#f0fbff';
            this.buttonSpacing = this.templateMeta.buttonSpacing || '';
            this.paragraphSpacing = this.templateMeta.paragraphSpacing || '';
            this.listSpacing = this.templateMeta.listSpacing || '';
            this.replaceToProjectLogo();
            this.changeDetector.markForCheck();
          }, 200);
        }
      }
    }, (reason) => {
    });
  }


  openEditorFullscreen(campaignId, influencerTypeId, token, isPreview, editorUrl) {
    const existingIframe = document.getElementById('editorIframe');
    if (existingIframe) {
      existingIframe.remove();
    }

    const iframe = document.createElement('iframe');
    iframe.id = 'editorIframe';
    iframe.src = `${editorUrl}?campaignId=${campaignId}&influencerTypeId=${influencerTypeId}&token=${token}&isPreview=${isPreview}`;

    const firstElement = document.body.firstElementChild;
    document.body.insertBefore(iframe, firstElement);
  }

  resetTemplate() {
    Swal.fire({
      title: 'This action will reset current template. Are you sure you want to continue?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Close',
      width: '55%'
    }).then(result => {
      if (result.value) {
        if (this.template.source_template_id) {
          this.resettingTemplate = true;
          this.templateStore.dispatch(ResetTemplateState({params: {template: null}}));
          this.templateStore.dispatch(TemplateGet({templateId: this.template.source_template_id}));
        }
      }
    });
  }

  applyCampaign(campaign, segment) {
    this.sendsEmail = campaign.email_disabled !== 'true';
    if (!this.sendsEmail) {
      this.isTestEmailDisable = true;
      this.campaignForm.controls['email_from_name'].disable();
      this.campaignForm.controls['email_from'].disable();
      this.campaignForm.controls['email_reply_to'].disable();
      this.campaignForm.controls['email_subject'].disable();
      this.campaignForm.controls['emails_source_message'].disable();
    }
    this.campaignForm.patchValue({
      email_from_name: campaign.email_from_name || '',
      email_from: campaign.email_from || '',
      email_reply_to: campaign.email_reply_to || '',
      email_subject: campaign.email_subject || '#InfluencerFName#, why not invite others to #ProjectTitle#?',
      emails_source_message: campaign.emails_source_message || '',
      segment: segment[0]?.name || '',
      email_sender_verify_by: campaign.email_sender_verify_by,
      email_sender_service_provider_id: campaign.email_sender_service_provider_id || null,
      email_sender_service_provider_slug: campaign.service_provider_slug || 'aws_ses',
      email_disabled: campaign.email_disabled || 'false'
    });
    this.previousFromEmail = campaign.email_from || '';

    const fromParts = this.splitEmail(campaign.email_from || '');
    this.fromEmailLocal = fromParts.local;
    this.fromEmailDomain = fromParts.domain;

    const replyToParts = this.splitEmail(campaign.email_reply_to || '');
    this.replyToEmailLocal = replyToParts.local;
    this.replyToEmailDomain = replyToParts.domain;

    this.syncFromEmail();
    this.syncReplyToEmail();
    this.loadAllowedDomains();
  }

  initializeCampaignForm() {
    const restrictedDomainValidator = (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (!email) {
        return null;
      }

      const restrictedDomains = ['snoball.events', 'snoball.it'];
      const emailDomain = email.split('@')[1]?.toLowerCase();
      if (!this.currentUser?.can('use-restricted-email-domains', 'campaign') && emailDomain && restrictedDomains.includes(emailDomain)) {
        return { restrictedDomain: 'Please use an email address from your own domain (e.g., @example.com) for the \'From\' and \'Reply-To\'' };
      }

      return null;
    };

    this.campaignForm = this.formBuilder.group({
      email_from_name: new FormControl<string | null>('', [Validators.required]),
      email_from: new FormControl<string | null>('', [Validators.required, Validators.email, restrictedDomainValidator]),
      email_reply_to: new FormControl<string | null>('', [Validators.required, Validators.email, restrictedDomainValidator]),
      // The server's limit (Campaign.service), so that the field says it before a save is refused.
      email_subject: new FormControl<string | null>('#InfluencerFName#, why not invite others to #ProjectTitle#?', [Validators.required, Validators.maxLength(1024)]),
      emails_source_message: new FormControl<string | null>('', []),
      segment: new FormControl<string | null>('', [Validators.required]),
      email_sender_verify_by: new FormControl<string | null>('', [Validators.required]),
      email_sender_service_provider_id: new FormControl<number | null>(null, []),
      email_sender_service_provider_slug: new FormControl<string | null>(null, []),
      email_disabled: new FormControl<string | null>('false', []),
    });
    const emailAddress = this.campaignForm.get('email_from');
    emailAddress.valueChanges.subscribe(() => {
      emailAddress.patchValue(emailAddress.value.toLowerCase(), {emitEvent: false});
      emailAddress.updateValueAndValidity({emitEvent: false});
    });
  }

  previewEmailTemplate() {
    this.templateGeneratorService.sendTestEmail('no-reply@snoball.it');
  }

  autoGrow(element) {
    element.style.height = '5px';
    element.style.height = (element.scrollHeight + 15) + 'px';
  }

  showVerificationStatus() {
    const domain = this.fromEmailDomain;
    if (!domain) {
      return;
    }
    const status = (this.fromEmailVerified === 'verified' ? 'verified' : 'unverified') as 'verified' | 'unverified';
    this.openVerificationModalForIdentity(domain, status);
  }

  initTestForm(): void {
    this.testMailForm = this.formBuilder.group({
      timezone: new FormControl<any>(null),
      recipients: this.formBuilder.array([ this.createRecipient(true) ])
    });
  }

  createRecipient(isFirst: boolean, email= ''): RecipientForm {
    const emailValue = (isFirst && this.currentUser?.email) ? this.currentUser.email : email;
    return this.formBuilder.group({
      email: new FormControl<string | null>(emailValue, [Validators.required, Validators.email]),
    });
  }

  addRecipient(): void {
    this.recipients = this.testMailForm.controls.recipients;
    this.recipients.push(this.createRecipient(false));
  }

  removeRecipient(recipient): void {
    this.recipients = this.testMailForm.controls.recipients;
    this.formLenght$.next(this.recipients.length);
    if (this.recipients.length === 1) {
      return;
    }
    this.recipients.removeAt(recipient);
  }

  showNewEditor() {
    if (this.newEditor.active || this.template?.visual_editor_id || !this.template?.id) {
      this.newEditor.show = true;
      return;
    }
    // A legacy email has no editor document of its own: the server converts its saved HTML
    // into one, inside the email layout, on an editor read.
    this.loaderService.show();
    this.templateService.get(this.template.id).subscribe({
      next: (resp: any) => {
        this.loaderService.hide();
        this.templateData = {...this.templateData, bodyJson: resp?.data?.body_json ?? null};
        this.newEditor.show = true;
        this.changeDetector.markForCheck();
      },
      error: (error) => {
        this.loaderService.hide(true);
        this.toastr.error(this.loaderService.getErrorMessage(error));
      }
    });
  }

  onEditorStateChanged(event: { action: string; body: any; bodyJson: string; visualEditorId: any }) {
    if (event.action === 'save') {
      this.templateData = {
        body: event.body,
        bodyJson: event.bodyJson ? JSON.parse(event.bodyJson) : null,
        visualEditorId: event.visualEditorId,
        campaignId: this.template.campaign_id,
        influencerTypeId: this.template.influencer_type_id,
        templateId: this.template.id,
        templateTypeId: this.template.template_type_id
      };
      this.newEditor.active = true;
      this.newEditor.show = false;
      this.editorSaved = false;
      this.editorSavePending = true;
      // Only the template: save() would also send a campaign form Next has not validated yet.
      this.onEditorChange({body: this.templateData.body, body_json: this.templateData.bodyJson,
        styles: null, visual_editor_id: this.templateData.visualEditorId});
      return;
    }
    if (event.action === 'undo-all') {
      this.showNewEditorTemplateRevisions();
      return;
    }
    this.newEditor.show = false;
  }

  showNewEditorTemplateRevisions() {
    const modelRef = this.sbModal.openComponent(TemplateRevisionsComponent, {
      centered: true, keyboard: true, size: 'xl',
      windowClass: 'above-editor-modal',
      backdropClass: 'above-editor-modal-backdrop'
    }, {
      templateId: this.template?.id,
      canReset: false,
    });
    modelRef.result.then((result) => {
      const newEditorRef = this.newEditorRef();
      if (result.data && newEditorRef) {
        newEditorRef.loadTemplate(result.data);
      }
    }, () => {});
  }

  startResizing(event: PointerEvent) {
    startPanelResize(event, this.panelWidth, width => {
      this.panelWidth = width;
      this.changeDetector.markForCheck();
    });
  }

  togglePanel() {
    this.panelCollapsed = !this.panelCollapsed;
    if (this.panelCollapsed) {
      this.panelWidth = 25;
    } else {
      this.panelWidth = this.defaultPanelWidth;
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
    this.templateGeneratorService.unsubscribe();
  }

  protected readonly project = project;
}
